import { render, staticRenderFns } from "./Citas.vue?vue&type=template&id=6dad791c"
import script from "./Citas.vue?vue&type=script&lang=js"
export * from "./Citas.vue?vue&type=script&lang=js"
import style0 from "./Citas.vue?vue&type=style&index=0&id=6dad791c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports